export const paginationLimit = 20
export const txnsPaginationLimit = 10
export const blocksPaginationLimit = 10
export const blocksQueryCount = 1000
export const validatorDelegationsLimit = 1000
export const positionsPaginationLimit = 10
export const tradesPaginationLimit = 20
export const userTradesPaginationLimit = 5
export const userInternalTransferPaginationLimit = 5
export const userTransactionsPaginationLimit = 5